// Custom React hook for analytics tracking
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackTimeOnPage } from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());
  const prevLocationRef = useRef();

  useEffect(() => {
    // Track page view when location changes
    if (location.pathname !== prevLocationRef.current) {
      // Track time spent on previous page
      if (prevLocationRef.current) {
        const timeSpent = Math.round((Date.now() - startTimeRef.current) / 1000);
        trackTimeOnPage(prevLocationRef.current, timeSpent);
      }

      // Track new page view
      trackPageView(location.pathname, document.title);
      
      // Reset timer for new page
      startTimeRef.current = Date.now();
      prevLocationRef.current = location.pathname;
    }
  }, [location]);

  // Track time spent when component unmounts
  useEffect(() => {
    return () => {
      if (prevLocationRef.current) {
        const timeSpent = Math.round((Date.now() - startTimeRef.current) / 1000);
        trackTimeOnPage(prevLocationRef.current, timeSpent);
      }
    };
  }, []);
};

export default useAnalytics;
